import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import StockControlList from "./StockControlList";
import AddStock from "./AddStock";
import TransferStock from "./TransferStock";
import ReturnStock from "./ReturnStock";
import ViewStock from "./ViewStock";
import EditDetails from "./EditDetails";
//import InventoryCountCreate from "./InventoryCountCreate"/
//import InventoryCountList from "./InvnetoryCountList";
const StockControl = ({ match }) => (
  <Switch>
    <Redirect
      exact
      from={`${match.url}/`}
      to={`${match.url}/stockcontrollist`}
    />
    <Route
      path={`${match.url}/stockcontrollist`}
      component={StockControlList}
    />
    <Route path={`${match.url}/addstock`} component={AddStock} />
    <Route path={`${match.url}/receivestock/:mode`} component={AddStock} />
    <Route path={`${match.url}/transferstock`} component={TransferStock} />
    <Route path={`${match.url}/returnstock`} component={ReturnStock} />
    <Route path={`${match.url}/viewstock/:id`} component={ViewStock} />
    <Route path={`${match.url}/edit/:id/:isReceived`} component={EditDetails} />
  </Switch>
);

export default StockControl;
